import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const MyAcademyTeachersService = sdk.getService('MyAcademyTeachersService');

export const useTeachersForStudentsList = () => {
  const { isLoading, data = [] } = useQuery({
    queryKey: ['my-academy', 'teachers', 'for-students'],
    queryFn: () => MyAcademyTeachersService.getTeachersForStudents()
  });

  return {
    teachers: data,
    isLoading
  };
};
